import React from "react";
import { Resources } from "../../../data/Resources";
import MediaFeedContentPage from "../media-feed/MediaFeedContentPage";

export const PodcastFeedPage = () => {
  return <MediaFeedContentPage resource={Resources.PODCASTS} />;
};
